export enum CreatePenCardFormField {
  Index = 'index',
  Asbvs = 'asbvs',
  Logo = 'logo',
}
